import DATA from '../actionTypes';

import { AppAction } from '../../../types/app';
import { DataState } from '../types';

const initialState: DataState = {
  readyStatus: DATA.LOAD.INVALID,
  err: null,
  config: null,
  broker: null,
  cookie: null,
  userAgent: __CLIENT__ ? window?.navigator.userAgent : '',
  location: null,
  prefix: null,
};

export default (
  state: DataState = initialState,
  action: AppAction = {}
): DataState => {
  switch (action.type) {
    case DATA.LOAD.REQUESTING:
      return {
        ...state,
        err: null,
        readyStatus: action.type,
      };
    case DATA.LOAD.FAILURE:
      return {
        ...state,
        err: action.err,
        readyStatus: action.type,
      };
    case DATA.LOAD.SUCCESS:
      return {
        ...state,
        err: null,
        readyStatus: action.type,
        config: action.config,
        broker: action.broker,
      };
    case DATA.SET.LOCATION:
      return {
        ...state,
        location: action.data,
      };
    case DATA.SET.PREFIX:
      return {
        ...state,
        prefix: action.data,
      };
    case DATA.SET.USER_AGENT:
      return {
        ...state,
        userAgent: action.data,
      };
    case DATA.SET.COOKIES:
      return {
        ...state,
        cookie: action.data,
      };
    default:
      return state;
  }
};
